module.exports = __webpack_public_path__ + "static/img/JP.b1c7d212.png";